import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { INCLUDE_EXCLUDE_OPTIONS } from '../../fieldsConfig';

const IncludeMultiselectValue = ({ rule, onValueChange }) => (
  <div className='include-multiselect'>
    <Dropdown
      selection
      options={INCLUDE_EXCLUDE_OPTIONS}
      value={rule.includeExclude}
      onChange={(e, data) => onValueChange(rule.instanceId, 'includeExclude', data.value)}
    />
    <Dropdown
      multiple
      selection
      options={rule.valueOptions}
      value={rule.selectedValues}
      onChange={(e, data) => onValueChange(rule.instanceId, 'selectedValues', data.value)}
      placeholder='Select options...'
    />
  </div>
);

IncludeMultiselectValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default IncludeMultiselectValue;
